const eventItemFooter = (params) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `footer_navigation_bar_button`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on ${params?.title?.toLowerCase()}`,
    eventLabel: `${params?.category ? params?.category : params?.title?.toLowerCase()}`,
  });
};
export default eventItemFooter;
